import React, { Component } from "react";
import { startCase } from "lodash";
import Formatters from '../../shared/utils/Formatters';
import pdf_icon from "../../../assets/images/pdf-icon.png";

class TradeDocument extends Component {
  placeholderImage(img = 'collections') {
    return (
      <div className='thumb'>
        <i className='materialIcon --medium -danger'>{img}</i>
      </div>
    );
  }

  get primaryImage() {
    if(!this.props.attachment_url) {
      return this.placeholderImage();
    }

    const extension = this.props.attachment_url.split(/#|\?/)[0].split('.').pop().trim();
    return (extension !== 'pdf') ? <img src={this.props.attachment_url} alt='thumb' className='thumb' /> : <img src={pdf_icon} alt='thumb' className="thumb"/>;
  }

  get title() {
    return (this.props.business_connection || {}).company_name ||
      this.props.buyer_name ||
      `#${this.props.trade_doc_type} #${this.props.id}`;
  }

  get prefix(){
    return this.props.trade_doc_type === 'Invoice' ? 'INV': 'PO';
  }

  get identifier(){
    return `${this.prefix}-${this.props.index}`
  }

  get buyerName(){
    return this.props.buyer_name
  }

  get subText(){
    if (this.props.amount) {
      const amount = Number(this.props.amount)
      return Formatters.currency({ amount: amount });
    } else {
      return <p className='byline'>{`Uploaded ${this.props.time_ago }`}</p>
    }
  }

  renderNotice = () => {
    if(this.props.action_required) {
      return (
        <div className="ds-notice -warning --small">
          <p className="byline">We need your help! Click to view more details</p>
        </div>
      );
    }

    return (
      <div className="ds-notice -success --small">
        <p className="byline">Loan offer received! Click to view more details</p>
      </div>
    );
  };

  statusClassNames = (status) => {
    switch(true) {
      case this.props.action_required:
        return '-warning';
      case ['rejected', 'loan_offer_expired'].includes(status):
        return '-danger';
      case ['verified', 'disbursed', 'loan_offer_accepted', 'loan_offer_sent'].includes(status):
        return '-success';
      case ['for_final_assessment'].includes(status):
        return '-secondary';
      default:
        return '-primary';
    }
  }

  render() {
    return (
      <a data-test='tradeDocCard-link' className={`cardSection _withColumns _simple _noMinHeight ${this.props.action_required ? '-bgWarningLight' : ''}`} onClick={this.props.onClick}>
        { this.primaryImage }
        <div className='text __widthAuto'>
          <small className={`preamble --small ${this.statusClassNames(this.props.stage)}`}>
            { this.props.action_required ? 'Action Required' : startCase(this.props.stage) }
          </small>
          <p className='label emphasize _truncated-mobileViewOnly --small'>
            { this.buyerName }
          </p>
          <small className='byline'>
            <div className='ds-status -secondary _marginRight--xxsmall'>
              { this.identifier }
            </div>
            { this.subText }
          </small>
        </div>
        <i className='materialIcon --small _right'
           onClick={this.props.onClick}>
          keyboard_arrow_right
        </i>
      </a>
    );
  }
}

export default TradeDocument;



// WEBPACK FOOTER //
// ./src/features/trade_documents/components/TradeDocument.js